import React, { createContext, type ReactNode, useContext } from 'react';

import { type Web3AuthPanelRenderContext } from '../Web3Auth.types';

interface Web3RenderContextType {
    renderCtx?: Web3AuthPanelRenderContext;
}

interface Web3RenderContextProviderProps {
    children: ReactNode;
    renderCtx?: Web3AuthPanelRenderContext;
}

const RenderContext = createContext<Web3RenderContextType>({
    renderCtx: undefined,
});

export const useWeb3RenderContext = () => useContext(RenderContext);

export function Web3RenderContextProvider({ children, renderCtx }: Web3RenderContextProviderProps) {
    return <RenderContext.Provider value={{ renderCtx }}>{children}</RenderContext.Provider>;
}
